import axios from 'axios'
import { baseURL } from './config.js'
import qs from 'qs'

// 
export default {
  getListPage(params) { // 积分兑换列表
    const url =  baseURL + '/tbCreditsExchange/getListPage';
    return axios.post(url, qs.stringify(params));
  },

  updateStatus(params) { // 修改
    const url =  baseURL + '/tbCreditsExchange/updateStatus';
    return axios.post(url, qs.stringify(params));
  },

  exportWbs(params) { // 导出
    const url =  baseURL + '/tbCreditsExchange/exportWbs';
    return url;
  },

  // 积分查询列表
  getcreditsPage(params) { 
    const url =  baseURL + '/tbUser/userPointList';
    return axios.post(url, qs.stringify(params));
  },

  exportCreditsExcel(params) { // 用户积分表
    const url =  baseURL + '/tbUser/userPointExcel';
    return url;
  }

}


// WEBPACK FOOTER //
// ./src/api/integral.js